<div class="ui modal" id="Language_Modal">
  <div class="content">
    <div class="AllScreen_Languages_Box" [ngStyle]="{'background-color' : this.selectedLanguage == 6 ? 'orange' : ''}" (click)="changeLanguage(6,'de')">
      <button class="AllScreen_Languages_Buttons" style="background-image:url(../../../Images/language-icons/de.png)"></button>
      <span class="AllScreen_Languages_Names">
        Deutsch
      </span>
    </div>
    <div class="AllScreen_Languages_Box" [ngStyle]="{'background-color' : this.selectedLanguage == 2 ? 'orange' : ''}" (click)="changeLanguage(2,'en')">
      <button class="AllScreen_Languages_Buttons" style="background-image:url(../../../Images/language-icons/en.png)"></button>
      <span class="AllScreen_Languages_Names">
        English
      </span>
    </div>
    <div class="AllScreen_Languages_Box" [ngStyle]="{'background-color' : this.selectedLanguage == 3 ? 'orange' : ''}" (click)="changeLanguage(3,'tr')">
      <button class="AllScreen_Languages_Buttons" style="background-image:url(../../../Images/language-icons/tr.png)"></button>
      <span class="AllScreen_Languages_Names">
        Türkçe
      </span>
    </div>
    <div class="AllScreen_Languages_Box" [ngStyle]="{'background-color' : this.selectedLanguage == 5 ? 'orange' : ''}" (click)="changeLanguage(5,'ru')">
      <button class="AllScreen_Languages_Buttons" style="background-image:url(../../../Images/language-icons/ru.png)"></button>
      <span class="AllScreen_Languages_Names">
        русский
      </span>
    </div>
    <div class="AllScreen_Languages_Box" [ngStyle]="{'background-color' : this.selectedLanguage == 12 ? 'orange' : ''}" (click)="changeLanguage(12,'pl')">
      <button class="AllScreen_Languages_Buttons" style="background-image:url(../../../Images/language-icons/pl.png)"></button>
      <span class="AllScreen_Languages_Names">
        Polskie
      </span>
    </div>
    <div class="AllScreen_Languages_Box" [ngStyle]="{'background-color' : this.selectedLanguage == 14 ? 'orange' : ''}" (click)="changeLanguage(14,'fr')">
      <button class="AllScreen_Languages_Buttons" style="background-image:url(../../../Images/language-icons/fr.png)"></button>
      <span class="AllScreen_Languages_Names">
        Française
      </span>
    </div>
    <div class="AllScreen_Languages_Box" [ngStyle]="{'background-color' : this.selectedLanguage == 7 ? 'orange' : ''}" (click)="changeLanguage(7,'es')">
      <button class="AllScreen_Languages_Buttons" style="background-image:url(../../../Images/language-icons/es.png)"></button>
      <span class="AllScreen_Languages_Names">
        Española
      </span>
    </div>
    <div class="AllScreen_Languages_Box" [ngStyle]="{'background-color' : this.selectedLanguage == 15 ? 'orange' : ''}" (click)="changeLanguage(15,'el')">
      <button class="AllScreen_Languages_Buttons" style="background-image:url(../../../Images/language-icons/gr.png)"></button>
      <span class="AllScreen_Languages_Names">
        Ελληνικά
      </span>
    </div>
    <div class="AllScreen_Languages_Box" [ngStyle]="{'background-color' : this.selectedLanguage == 17 ? 'orange' : ''}" (click)="changeLanguage(17,'bg')">
      <button class="AllScreen_Languages_Buttons" style="background-image:url(../../../Images/language-icons/bg.png)"></button>
      <span class="AllScreen_Languages_Names">
        български
      </span>
    </div>
    <div class="AllScreen_Languages_Box" [ngStyle]="{'background-color' : this.selectedLanguage == 19 ? 'orange' : ''}" (click)="changeLanguage(19,'da')">
      <button class="AllScreen_Languages_Buttons" style="background-image:url(../../../Images/language-icons/dk.png)"></button>
      <span class="AllScreen_Languages_Names">
        Dansk
      </span>
    </div>
    <div class="AllScreen_Languages_Box" [ngStyle]="{'background-color' : this.selectedLanguage == 20 ? 'orange' : ''}" (click)="changeLanguage(20,'ro')">
      <button class="AllScreen_Languages_Buttons" style="background-image:url(../../../Images/language-icons/ro.png)"></button>
      <span class="AllScreen_Languages_Names">
        Română
      </span>
    </div>
    <div class="AllScreen_Languages_Box" [ngStyle]="{'background-color' : this.selectedLanguage == 22 ? 'orange' : ''}" (click)="changeLanguage(22,'it')">
      <button class="AllScreen_Languages_Buttons" style="background-image:url(../../../Images/language-icons/it.png)"></button>
      <span class="AllScreen_Languages_Names">
        Italiano
      </span>
    </div>
    <div class="AllScreen_Languages_Box" [ngStyle]="{'background-color' : this.selectedLanguage == 11 ? 'orange' : ''}" (click)="changeLanguage(11,'pt')">
      <button class="AllScreen_Languages_Buttons" style="background-image:url(../../../Images/language-icons/pt.png)"></button>
      <span class="AllScreen_Languages_Names">
        Português
      </span>
    </div>
    <div class="AllScreen_Languages_Box" [ngStyle]="{'background-color' : this.selectedLanguage == 16 ? 'orange' : ''}" (click)="changeLanguage(16,'sq')">
      <button class="AllScreen_Languages_Buttons" style="background-image:url(../../../Images/language-icons/sq.png)"></button>
      <span class="AllScreen_Languages_Names">
        Shqip
      </span>
    </div>
    <!--<div class="AllScreen_Languages_Box" [ngStyle]="{'background-color' : this.selectedLanguage == 11 ? 'orange' : ''}" (click)="changeLanguage(11,'fr')">
      <button class="AllScreen_Languages_Buttons" style="background-image:url(../../../Images/language-icons/fr.png)"></button>
      <span class="AllScreen_Languages_Names">
          Français
      </span>
  </div>
  <div class="AllScreen_Languages_Box" [ngStyle]="{'background-color' :this.selectedLanguage == 12 ? 'orange' : ''}" (click)="changeLanguage(12,'hr')">
      <button class="AllScreen_Languages_Buttons" style="background-image:url(../../../Images/language-icons/hr.png)"></button>
      <span class="AllScreen_Languages_Names">
          Croatian
      </span>
  </div>
  <div class="AllScreen_Languages_Box" [ngStyle]="{'background-color' : this.selectedLanguage == 7 ? 'orange' : ''}" (click)="changeLanguage(7,'es')">
      <button class="AllScreen_Languages_Buttons" style="background-image:url(../../../Images/language-icons/es.png)"></button>
      <span class="AllScreen_Languages_Names">
          Español
      </span>
  </div>
  <div class="AllScreen_Languages_Box" [ngStyle]="{'background-color' : this.selectedLanguage == 13 ? 'orange' : ''}" (click)="changeLanguage(13,'it')">
      <button class="AllScreen_Languages_Buttons" style="background-image:url(../../../Images/language-icons/it.png)"></button>
      <span class="AllScreen_Languages_Names">
          Italiano
      </span>
  </div>
  <div class="AllScreen_Languages_Box" [ngStyle]="{'background-color' : this.selectedLanguage == 14 ? 'orange' : ''}" (click)="changeLanguage(14,'sq')">
      <button class="AllScreen_Languages_Buttons" style="background-image:url(../../../Images/language-icons/sq.png)"></button>
      <span class="AllScreen_Languages_Names">
          Shqip
      </span>
  </div>
  <div class="AllScreen_Languages_Box" [ngStyle]="{'background-color' : this.selectedLanguage == 15 ? 'orange' : ''}" (click)="changeLanguage(15,'cs')">
      <button class="AllScreen_Languages_Buttons" style="background-image:url(../../../Images/language-icons/cs.png)"></button>
      <span class="AllScreen_Languages_Names">
          Cesky
      </span>
  </div>
  <div class="AllScreen_Languages_Box" [ngStyle]="{'background-color' : this.selectedLanguage == 16 ? 'orange' : ''}" (click)="changeLanguage(16,'sk')">
      <button class="AllScreen_Languages_Buttons" style="background-image:url(../../../Images/language-icons/sk.png)"></button>
      <span class="AllScreen_Languages_Names">
          Slovensky
      </span>
  </div>
  <div class="AllScreen_Languages_Box" [ngStyle]="{'background-color' : this.selectedLanguage == 17 ? 'orange' : ''}" (click)="changeLanguage(17,'ru')">
      <button class="AllScreen_Languages_Buttons" style="background-image:url(../../../Images/language-icons/ru.png)"></button>
      <span class="AllScreen_Languages_Names">
          Pусский
      </span>
  </div>-->
  </div>
</div>
